"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Logo;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _image = _interopRequireDefault(require("./image"));

function Logo({
  title,
  image,
  width,
  height,
  link
}) {
  if (link) {
    return /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
      to: link,
      className: "navbar-logo"
    }, /*#__PURE__*/_react.default.createElement(_image.default, {
      title: title,
      image: image,
      width: width,
      height: height
    }));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "navbar-logo"
    }, /*#__PURE__*/_react.default.createElement(_image.default, {
      title: title,
      image: image,
      width: width,
      height: height
    }));
  }
}

Logo.propTypes = {
  image: _propTypes.default.string,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  title: _propTypes.default.string,
  link: _propTypes.default.string
};
Logo.defaultProps = {
  link: "/"
};